import { render, staticRenderFns } from "./segment-subscribed-button.vue?vue&type=template&id=4367d283"
import script from "./segment-subscribed-button.vue?vue&type=script&lang=js"
export * from "./segment-subscribed-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports